import axios from "axios";
import {getToken} from "./auth.service";

const generateMyFriendEndpoint = (search:String, limit:any, offset:any) => {
    return `/api/v1/users/friends?search=${search}&limit=${limit}&offset=${offset}`;
};
const generateMyฺBlockFriendsEndpoint = (search:String, limit:any, offset:any) => {
    return `/api/v1/users/all/blocked-user?search=${search}&limit=${limit}&offset=${offset}`;
};

export const APIEndpoint = {
    myFriend: generateMyFriendEndpoint,
    myBlockFriend:generateMyฺBlockFriendsEndpoint,
};

export const findMyFriend = async (search:String, limit:any, offset:any) => {
    return await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.myFriend(search, limit, offset),
        {
            headers: { Authorization: `Bearer ${getToken()}` },
        }
    );
};
export const findMyฺBlockFriends = async (search:String, limit:any, offset:any) => {
    return await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.myBlockFriend(search, limit, offset),
        {
            headers: { Authorization: `Bearer ${getToken()}` },
        }
    );
};